<section class="evidence-section">
  <div class="section py-3 pb-lg-80 px-lg-5 position-relative">
    <div class="container">
      <h2 class="mb-4">{{ data.thematic_sites_title ?? "" }}</h2>
      <div class="pt-4 pt-lg-30">
        <div class="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal card-teaser-block-3 pb-0">
          <a *ngFor="let site of data?.thematic_sites_cards" [href]="site?.alias"
            class="card card-teaser rounded mt-0 p-3" [ngClass]="{'ct-bg-light':site.colour=='1', 'ct-bg-gray':site.colour=='2', 'ct-bg-dark':site.colour=='3'}" data-focus-mouse="false">
            <div class="avatar bg-white size-lg me-3">
              <svg *ngIf="site?.icon_text; else UseLinkIcon" class="icon" aria-hidden="true" [attr.aria-label]="site?.icon_text">
                <use [attr.href]="'bootstrap-italia/dist/svg/sprites.svg#'+site.icon_text"></use>
              </svg>
              <ng-template #UseLinkIcon>
                <svg class="icon" aria-hidden="true" aria-label="Icona link">
                  <use href="bootstrap-italia/dist/svg/sprites.svg#it-link"></use>
                </svg>
              </ng-template>
            </div>
            <div class="card-body">
              <h3 class="card-title sito-tematico">
                {{site?.title}}
              </h3>
              <p class="card-text text-sans-serif" [innerHTML]="substring(site?.description,0,255)">
              </p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>